import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getActionMessageInfo } from 'automation-ui-action-features/actions/rotate-object/utils/action-message';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnifiedRoutingContactOwnerPreview = ({
  objectTypeId,
  routingRuleDefinition
}) => {
  const elements = {
    ObjectTypeName
  };
  const {
    distribution,
    teamCount,
    type,
    userCount
  } = getActionMessageInfo(routingRuleDefinition);
  if (type === '') {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: elements,
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.contact-owner.no-one_jsx",
      options: {
        objectTypeId
      }
    });
  }
  const getFallbackMessage = () => {
    switch (type) {
      case 'multiple-both':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.contact-owner.users-and-teams.multiple-both_jsx",
          options: {
            distribution,
            objectTypeId,
            teamCount,
            userCount
          }
        });
      case 'single-both':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.contact-owner.users-and-teams.single-both_jsx",
          options: {
            distribution,
            objectTypeId,
            teamCount,
            userCount
          }
        });
      case 'single-team':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.contact-owner.users-and-teams.single-team_jsx",
          options: {
            distribution,
            objectTypeId,
            teamCount,
            userCount
          }
        });
      case 'single-user':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.contact-owner.users-and-teams.single-user_jsx",
          options: {
            distribution,
            objectTypeId,
            teamCount,
            userCount
          }
        });
      case 'teams-only':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.contact-owner.teams-only_jsx",
          options: {
            count: teamCount,
            distribution,
            objectTypeId
          }
        });
      case 'users-only':
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: elements,
          message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.contact-owner.users-only_jsx",
          options: {
            count: userCount,
            distribution,
            objectTypeId
          }
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: elements,
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-preview.contact-owner.base_jsx",
      options: {
        objectTypeId
      }
    }), getFallbackMessage()]
  });
};
UnifiedRoutingContactOwnerPreview.displayName = 'UnifiedRoutingContactOwnerPreview';